import { BadRequestErrorDataModel } from '../models/errors/bad-request-data-model'
import { AppError } from './app-error'

export namespace BadRequestError {
  export type Model = BadRequestErrorDataModel
}

export class BadRequestError extends AppError {
  private static NAME: string = 'BadRequestError'
  public static MESSAGE: string = 'Requisição inválida'

  public declare readonly message: string

  constructor(message?: string | null, data?: BadRequestError.Model) {
    super(BadRequestError.NAME, message ?? BadRequestError.MESSAGE)
    if (data) {
      this.message = Object.values(data).join(', ')
    }
  }
}
